<template>
    <div>

        <div class="generic-fullscreen generic-fullscreen-home" v-show="!isPhotos">
            <div class="model-fullscreen">
                <button id="openModelButton" type="button" class="btn btn-primary" data-toggle="modal" data-target="#videoGalleryModal"></button>
                <div class="modal fade" id="videoGalleryModal" tabindex="-1" role="dialog" aria-labelledby="videoGalleryModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <iframe id="existing-iframe-example" width="560" height="315" :src="galleryVideosArray" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="media-center">
            <div class="container">
                <div class="filter-data">
                    <span class="filter">{{Filter}}</span>
                    <multiselect v-model="filteredValue" :custom-label="nameWithLang" track-by="CategoryId" :options="options" :show-labels="false" :searchable="false" :allow-empty="false"></multiselect>
                </div>
                <div class="row">
                    <div class="col-md-4" v-bind:key="item.CategoryId" v-for="(item, index) in GenericGalleryData">
                        <div class="generic-card news-card">
                            <a :href="item.CategoryUrl" class="generic-card-link" v-show="isPhotos">
                                <div class="card-img">
                                    <img :src="item.CateogryThumbnail" alt="cateogry thumbnail" @error="replaceByDefaultImg" />
                                    <span class="imgs-number"><i class="icon-gallery"></i>{{item.PhotoCount}}</span>
                                </div>
                                <div class="card-content">
                                    <span class="card-category" v-if="item.CategoryTitle != null">{{item.CategoryTitle}}</span>
                                    <p class="card-details">{{item.GalleryTitle}}</p>
                                </div>
                            </a>
                            <a class="generic-card-link" v-show="!isPhotos">
                                <div class="card-img">
                                    <img :src="item.VideoThumbnail" alt="video thumbnail" @error="replaceByDefaultImg" />
                                    <div class="card-thumbnail" v-on:click="openVideoFullScreen(index)">
                                        <i class="icon-play-button"></i>
                                    </div>
                                </div>
                                <div class="card-content">
                                    <span class="card-category" v-if="item.CategoryTitle != null">{{item.CategoryTitle}}</span>
                                    <p class="card-details">{{item.VideoTitle}}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="generic-error-message" v-show="showNoDataMessage">
                    <p class="message-text"><span>{{Sorry}} </span>{{NoDataFound}}</p>
                </div>
                <div class="generic-loader" v-show="isAjaxLoading">
                    <img src="../../../../../src/assets/spinner.svg" alt="EDA Spinner" />
                </div>
            </div>
        </section>

    </div>
</template>

<script>

    import Multiselect from 'vue-multiselect'
    import "vue-multiselect/dist/vue-multiselect.min.css";
    import axios from 'axios';

    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";
    let contactApiUrl;
    let listingThis;

    export default {
        props: {
            Filter: {
                type: String
            },
            ViewAll: {
                type: String
            },
            Sorry: {
                type: String
            },
            NoDataFound: {
                type: String
            },
            lang: {
                type: String
            },
            isPhotos: {
                type: Boolean
            },
            API: {
                type: String
            },
            CategoriesList: {
                type: String
            }
        },
        components: {
            Multiselect
        },
        data() {
            return {
                GenericGalleryData: [],
                galleryVideosArray: [],
                filterData: [],
                isAjaxLoading: false,
                showNoDataMessage: false,
                isthierMoreData: true,
                scrollCount: 1,
                filteredCategory: "",
                filteredValue: "",
                options: [],
                fullScreenIndex: null,
                fullScreenOpen: "",
                fullScreenClose: "",
                videoID: null
            }
        },
        methods: {
            nameWithLang({ CategoryTitle }) {
                return `${CategoryTitle}`
            },
            getData: function () {
                listingThis.isAjaxLoading = true;
                contactApiUrl = `${apiUrl}/Umbraco/surface/${listingThis.API}?currentCulture=${listingThis.lang}&requiredPage=${listingThis.scrollCount}&filteredCategory=${listingThis.filteredCategory}`
                axios.get(contactApiUrl, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then(response => {

                    if (response.data != "") {
                        listingThis.showNoDataMessage = false;
                        if (listingThis.scrollCount == 1) {
                            listingThis.GenericGalleryData = response.data;
                        } else {
                            listingThis.GenericGalleryData = listingThis.GenericGalleryData.concat(response.data);
                        }
                    } else {
                        listingThis.isthierMoreData = false;
                        if (listingThis.scrollCount == 1) {
                            listingThis.GenericGalleryData = [];
                            listingThis.showNoDataMessage = true;
                        }
                    }

                    listingThis.isAjaxLoading = false;

                    let videoIndex = listingThis.GenericGalleryData.findIndex(x => x.Id == this.videoID );

                    if (this.videoID) {
                        this.openVideoFullScreen(videoIndex);
                    }

                    this.videoID = null;
                })
                //TODO Probably will need to make our dates disabled till load
            },
            replaceByDefaultImg(e) {
                e.target.src = "../../../../../src/assets/default.png";
            },
            getFilterOptions: function () {
                axios.get(`${apiUrl}/Umbraco/surface/${listingThis.CategoriesList}/GetAllGalleryCategoriesTitles?currentCulture=${listingThis.lang}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then(function (res) {
                    listingThis.options = [{ CategoryId: "", CategoryTitle: listingThis.ViewAll }]
                    res.data.forEach((item) => {
                        listingThis.options.push(item);
                    })
                })
            },
            changeUrlParams: function (paramValue) {
                let queryParams = new URLSearchParams(window.location.search);
                queryParams.delete("category");
                queryParams.set("category", paramValue);
                queryParams.delete("id");
                queryParams.set("id", listingThis.filteredValue.CategoryId);
                
                history.replaceState(null, null, "?" + queryParams.toString());
            },
            getUrlParams: function () {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const categoryId = urlParams.get('id');
                const categoryName = urlParams.get('category');
                if (categoryId != null && categoryName != null) {
                    listingThis.filteredValue = {
                        CategoryId: categoryId,
                        CategoryTitle: categoryName
                    }
                }
            },
            openVideoFullScreen: function (index) {
                listingThis.galleryVideosArray = listingThis.GenericGalleryData[index].VideoURL;
                setTimeout(function () {
                    document.getElementById("openModelButton").click();
                }, 100);
            }
        },
        beforeMount() {
            let url_string = window.location.href;
            let url = new URL(url_string);
            this.videoID = parseInt(url.searchParams.get("id"));
        },
        mounted() {
            listingThis = this;

            listingThis.getUrlParams();

            if (listingThis.filteredValue == "") {
                listingThis.filteredValue = { CategoryId: "", CategoryTitle: listingThis.ViewAll };
            }

            if (listingThis.scrollCount == 1 && listingThis.filteredValue == null) {
                listingThis.getData();
            }

            listingThis.getFilterOptions();

            let observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !listingThis.isAjaxLoading && listingThis.isthierMoreData) {
                        listingThis.scrollCount++;
                        listingThis.getData();
                    }
                });
            });

            //this is make cause footer content is loaded late so it's positions changed
            setTimeout(function () {
                const container = document.querySelector(".footer");
                observer.observe(container);
            }, 100);

            const domChangeObserver = new MutationObserver(mutation => {
                if (mutation[0].attributeName === 'class') {
                    listingThis.galleryVideosArray = "";
                }
            });

            domChangeObserver.observe(document.getElementById("videoGalleryModal"), {
                attributes: true
            });
        },
        watch: {
            'filteredValue.CategoryTitle': function () {
                listingThis.changeUrlParams(listingThis.filteredValue.CategoryTitle);
                listingThis.scrollCount = 1;
                listingThis.isthierMoreData = true;
                listingThis.filteredCategory = listingThis.filteredValue.CategoryId;
                listingThis.getData();
            }
        }
    }
</script>
